import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { getApiProblem, notifyProblem } from './form-feedback';

export function createPortalQueryClient() {
  const reportProblem = (error: unknown) => notifyProblem(getApiProblem(error).message);
  return new QueryClient({
    mutationCache: new MutationCache({ onError: reportProblem }),
    queryCache: new QueryCache({ onError: reportProblem }),
  });
}
